/**
 * The Admin/Viewer role-picker radio card, shared by every Pool Settings flow that needs one:
 * AddUserModal's step ② (grant) and ChangeRoleModal (30/7, change an EXISTING operator's role). Pulled
 * out of AddUserModal.tsx (its original home) rather than duplicated so the two flows can never drift
 * on the card's markup/a11y wiring — only the role LIST and what happens on submit differ between them.
 */
import { useId } from "react";
import { cn } from "@/lib/cn";

export function RoleCard({
  title,
  description,
  selected,
  onSelect,
}: {
  title: string;
  description: string;
  selected: boolean;
  onSelect: () => void;
}) {
  const titleId = useId();
  const descId = useId();
  return (
    <button
      type="button"
      role="radio"
      aria-checked={selected}
      aria-labelledby={titleId}
      aria-describedby={descId}
      onClick={onSelect}
      className={cn(
        "flex flex-col items-start gap-1.5 rounded-(--radius) border p-3 text-left transition-colors",
        "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--brand)",
        selected
          ? "border-(--brand) bg-(--brand-subtle)"
          : "border-(--border) bg-(--surface) hover:border-(--border-strong) hover:bg-(--surface-hover)",
      )}
    >
      <span id={titleId} className="text-(length:--text-sm) font-semibold text-(--text-strong)">
        {title}
      </span>
      <span id={descId} className="text-(length:--text-xs) text-(--text-muted)">
        {description}
      </span>
    </button>
  );
}
